import type { FaireProductEntity } from "../../entity_types/product";

export const p_qh7xe3bh9c: FaireProductEntity = {
  token: "p_qh7xe3bh9c",
  type: "product",
  name: "Thanks Vase Card",
  brandToken: "b_vup8x6ncrs",
  brandName: "Studio Conroy",
  imageUrl:
    "https://cdn.faire.com/fastly/8e831f82bf5a2a0388ba79d3ad196e46295a2b64ee523d35b0d084d457530c58.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/088e0349cbc0150b4d0a3b5fd20b6635535cde8dd76718b2b8648b95d6b843e7.png",
  ],
  priceDollars: 2.75,
  description:
    "• A2 (4.25 x 5.5\")\n• Blank inside so you can write your own special message.\n• Comes with a white envelope and protective cellophane sleeve.\n• We love imperfections! If you see a speckle or a dot, it's because these cards are printed on 100% recycled paper.\n• Made in California.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:55.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
